/* Noc's World — Shopify theme JS
 * Player, slideshow, videos, and store rendering. Data comes from
 * window.RELEASES / SONG_PRODUCTS / MERCH_PRODUCTS / GALLERY / VIDEOS,
 * which each section emits from its editable blocks (see the .liquid
 * sections). Cover/audio/gallery values are full Shopify URLs. */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* Editor-added singles (Music section blocks) go in front of the built-in catalog */
  window.RELEASES = (window.RELEASES_EXTRA || []).concat(window.RELEASES || []);

  /* ---------------- Music player ---------------- */
  var QUEUE = [];
  (window.RELEASES || []).forEach(function (rel) {
    (rel.tracks || []).forEach(function (t) {
      QUEUE.push({
        title: t.title,
        feat: t.feat || '',
        artist: t.feat ? 'Sirnoc feat. ' + t.feat : 'Sirnoc',
        cover: rel.cover || '',
        src: t.src || '',
        releaseId: rel.id
      });
    });
  });
  var firstIndexOf = {};
  QUEUE.forEach(function (q, i) { if (firstIndexOf[q.releaseId] === undefined) firstIndexOf[q.releaseId] = i; });

  var audio = document.getElementById('audio');
  var player = document.getElementById('player');
  var pCover = document.getElementById('pCover');
  var pTitle = document.getElementById('pTitle');
  var pArtist = document.getElementById('pArtist');
  var pPlay = document.getElementById('pPlay');
  var pPrev = document.getElementById('pPrev');
  var pNext = document.getElementById('pNext');
  var pSeek = document.getElementById('pSeek');
  var pCur = document.getElementById('pCur');
  var pDur = document.getElementById('pDur');
  var pVol = document.getElementById('pVol');
  var pMute = document.getElementById('pMute');
  var current = -1, seeking = false;

  function fmt(s) { if (!s || isNaN(s)) return '0:00'; var m = Math.floor(s / 60), x = Math.floor(s % 60); return m + ':' + (x < 10 ? '0' : '') + x; }
  function highlight() {
    var rid = current >= 0 ? QUEUE[current].releaseId : null;
    document.querySelectorAll('.release').forEach(function (el) { el.classList.toggle('is-playing', el.dataset.release === rid); });
    document.querySelectorAll('.atrack').forEach(function (el) { el.classList.toggle('is-playing', parseInt(el.dataset.index, 10) === current); });
  }
  function load(i, autoplay) {
    if (!audio || i < 0 || i >= QUEUE.length) return;
    current = i; var t = QUEUE[i];
    audio.src = t.src; pCover.src = t.cover; pCover.alt = t.title;
    pTitle.textContent = t.title; pArtist.textContent = t.artist;
    player.hidden = false; document.body.style.paddingBottom = '92px';
    if (autoplay !== false) play(); highlight();
  }
  function play() { var p = audio.play(); if (p && p.catch) p.catch(function () {}); }
  function togglePlay() { if (current < 0) { load(0); return; } if (audio.paused) play(); else audio.pause(); }
  function next() { load((current + 1) % QUEUE.length); }
  function prev() { if (audio.currentTime > 3) { audio.currentTime = 0; return; } load((current - 1 + QUEUE.length) % QUEUE.length); }

  window.NocPlayer = {
    playIndex: function (i) { load(i, true); },
    playRelease: function (id) { var i = firstIndexOf[id]; if (i !== undefined) load(i, true); },
    toggle: togglePlay
  };

  if (audio) {
    audio.addEventListener('play', function () { pPlay.innerHTML = '&#10074;&#10074;'; highlight(); });
    audio.addEventListener('pause', function () { pPlay.innerHTML = '&#9654;'; highlight(); });
    audio.addEventListener('ended', next);
    audio.addEventListener('timeupdate', function () { if (!seeking && audio.duration) pSeek.value = (audio.currentTime / audio.duration) * 100; pCur.textContent = fmt(audio.currentTime); });
    audio.addEventListener('loadedmetadata', function () { pDur.textContent = fmt(audio.duration); });
    pPlay.addEventListener('click', togglePlay);
    pNext.addEventListener('click', next);
    pPrev.addEventListener('click', prev);
    pSeek.addEventListener('input', function () { seeking = true; });
    pSeek.addEventListener('change', function () { if (audio.duration) audio.currentTime = (pSeek.value / 100) * audio.duration; seeking = false; });
    pVol.addEventListener('input', function () { audio.volume = parseFloat(pVol.value); audio.muted = false; pMute.innerHTML = audio.volume === 0 ? '&#128263;' : '&#128266;'; });
    pMute.addEventListener('click', function () { audio.muted = !audio.muted; pMute.innerHTML = audio.muted ? '&#128263;' : '&#128266;'; });
    document.addEventListener('keydown', function (e) {
      if (e.code === 'Space' && current >= 0) { var tag = (e.target.tagName || '').toLowerCase(); if (tag === 'input' || tag === 'textarea') return; e.preventDefault(); togglePlay(); }
    });
  }

  function renderReleases() {
    var wrap = document.getElementById('releases'); if (!wrap) return;
    var html = '';
    (window.RELEASES || []).forEach(function (rel) {
      if (rel.kind === 'album') return;
      var feat = rel.tracks && rel.tracks[0] && rel.tracks[0].feat ? rel.tracks[0].feat : '';
      var badgeText = rel.badge || (rel.kind === 'collection' ? 'Collection' : '');
      var badge = badgeText ? '<span class="release__badge">' + esc(badgeText) + '</span>' : '';
      html += '<div class="release" data-release="' + esc(rel.id) + '">' +
        '<div class="release__art"><img src="' + esc(rel.cover) + '" alt="' + esc(rel.title) + '" loading="lazy" />' + badge +
        '<div class="release__play">&#9654;</div></div>' +
        '<div class="release__info"><div class="release__title">' + esc(rel.title) + '</div>' +
        (feat ? '<div class="release__feat">feat. ' + esc(feat) + '</div>' : '') +
        '<div class="release__date">' + esc(rel.date) + '</div></div></div>';
    });
    wrap.innerHTML = html;
    wrap.querySelectorAll('.release').forEach(function (el) { el.addEventListener('click', function () { window.NocPlayer.playRelease(el.dataset.release); }); });
  }
  function renderAlbum() {
    var block = document.getElementById('albumBlock'); if (!block) return;
    var album = (window.RELEASES || []).filter(function (r) { return r.kind === 'album'; })[0];
    if (!album) { block.innerHTML = ''; return; }
    var rows = '';
    (album.tracks || []).forEach(function (t, i) {
      var qi = QUEUE.findIndex(function (q) { return q.releaseId === album.id && q.title === t.title; });
      rows += '<li class="atrack" data-index="' + qi + '"><span class="atrack__num">' + (i + 1) + '</span>' +
        '<span class="atrack__title">' + esc(t.title) + (t.feat ? ' <span class="atrack__feat">feat. ' + esc(t.feat) + '</span>' : '') + '</span>' +
        '<span class="atrack__icon">&#9654;</span></li>';
    });
    block.innerHTML = '<div class="album__head"><img class="album__cover" src="' + esc(album.cover) + '" alt="' + esc(album.title) + '" />' +
      '<div class="album__meta"><span class="release__badge" style="position:static;display:inline-block;margin-bottom:8px;">Album</span>' +
      '<h3>' + esc(album.title) + '</h3><div class="release__date">' + esc(album.date) + ' &middot; ' + (album.tracks || []).length + ' tracks</div></div></div>' +
      '<ul class="album__tracks">' + rows + '</ul>';
    block.querySelectorAll('.atrack').forEach(function (el) { el.addEventListener('click', function () { var i = parseInt(el.dataset.index, 10); if (i >= 0) window.NocPlayer.playIndex(i); }); });
  }

  /* ---------------- Slideshow ---------------- */
  function initGallery() {
    var stage = document.getElementById('slideStage');
    var dotsWrap = document.getElementById('slideDots');
    var images = (window.GALLERY || []).concat(window.GALLERY_EXTRA || []);
    if (!stage || !images.length) return;
    var current = 0, timer = null;
    var sH = '', dH = '';
    images.forEach(function (url, i) {
      sH += '<div class="slide" data-i="' + i + '"><div class="slide__bg" style="background-image:url(\'' + url + '\')"></div>' +
        '<img class="slide__img" src="' + url + '" alt="Sirnoc photo ' + (i + 1) + '" loading="lazy" /></div>';
      dH += '<button class="sdot" data-i="' + i + '" aria-label="Photo ' + (i + 1) + '"></button>';
    });
    stage.innerHTML = sH; dotsWrap.innerHTML = dH;
    var slides = [].slice.call(stage.querySelectorAll('.slide'));
    var dots = [].slice.call(dotsWrap.querySelectorAll('.sdot'));
    function show(n) { current = (n + slides.length) % slides.length; slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); }); dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); }); }
    function nx() { show(current + 1); }
    function start() { stop(); timer = setInterval(nx, 4500); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    document.getElementById('slideNext').addEventListener('click', function () { nx(); start(); });
    document.getElementById('slidePrev').addEventListener('click', function () { show(current - 1); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.dataset.i, 10)); start(); }); });
    var box = document.getElementById('slideshow');
    box.addEventListener('mouseenter', stop); box.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    show(0); start();
  }

  /* ---------------- Videos ---------------- */
  function ytId(u) {
    if (!u) return '';
    u = String(u).trim();
    var m = u.match(/[?&]v=([A-Za-z0-9_-]{11})/) || u.match(/(?:youtu\.be\/|\/embed\/|\/shorts\/)([A-Za-z0-9_-]{11})/);
    if (m) return m[1];
    return /^[A-Za-z0-9_-]{11}$/.test(u) ? u : '';
  }
  function renderVideos() {
    var grid = document.getElementById('videoGrid'); if (!grid) return;
    var vids = (window.VIDEOS || []).map(function (v) { return { title: v.title, yt: ytId(v.yt) }; }).filter(function (v) { return v.yt; });
    if (!vids.length) { grid.innerHTML = '<p class="videos__soon">Music videos coming soon — stay tuned.</p>'; return; }
    grid.innerHTML = vids.map(function (v) {
      var src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(v.yt) + '?rel=0&modestbranding=1';
      return '<figure class="video"><div class="video__frame"><iframe src="' + src + '" title="' + esc(v.title || 'Sirnoc video') + '" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe></div>' +
        (v.title ? '<figcaption class="video__cap">' + esc(v.title) + '</figcaption>' : '') + '</figure>';
    }).join('');
  }

  /* ---------------- Store (songs + merch) ---------------- */
  function buyBtn(p, label) {
    if (p.url) return '<a class="btn btn--gold btn--block" href="' + esc(p.url) + '">' + label + '</a>';
    return '<button class="btn btn--gold btn--block" type="button">' + label + '</button><p class="product__hint">Link this card to its Shopify product</p>';
  }
  function renderSongs() {
    var wrap = document.getElementById('songProducts'); if (!wrap) return;
    wrap.innerHTML = (window.SONG_PRODUCTS || []).map(function (p) {
      return '<div class="product"><div class="product__art"><img src="' + esc(p.cover) + '" alt="' + esc(p.title) + '" loading="lazy" /></div>' +
        '<div class="product__body"><div class="product__title">' + esc(p.title) + '</div>' +
        (p.feat ? '<div class="product__feat">feat. ' + esc(p.feat) + '</div>' : '') +
        '<div class="product__price">$' + esc(p.price) + '</div>' +
        '<div class="product__buy">' + buyBtn(p, 'Buy &middot; $' + esc(p.price)) + '</div></div></div>';
    }).join('');
  }
  function renderMerch() {
    var wrap = document.getElementById('merchProducts'); if (!wrap) return;
    wrap.innerHTML = (window.MERCH_PRODUCTS || []).map(function (p) {
      return '<div class="product"><div class="product__art product__art--merch">&#9733;</div>' +
        '<div class="product__body"><div class="product__title">' + esc(p.title) + '</div>' +
        (p.note ? '<div class="product__note">' + esc(p.note) + '</div>' : '') +
        '<div class="product__price">$' + esc(p.price) + '</div>' +
        '<div class="product__buy">' + buyBtn(p, 'Add to Cart &middot; $' + esc(p.price)) + '</div></div></div>';
    }).join('');
  }

  /* ---------------- Chrome (nav, hero, reveal) ---------------- */
  function wireChrome() {
    var heroPlay = document.getElementById('heroPlay');
    if (heroPlay) heroPlay.addEventListener('click', function () { if (current < 0) load(0); else togglePlay(); var m = document.getElementById('music'); if (m) m.scrollIntoView({ behavior: 'smooth' }); });
    var toggle = document.getElementById('navToggle'), links = document.querySelector('.nav__links');
    if (toggle && links) { toggle.addEventListener('click', function () { links.classList.toggle('is-open'); }); links.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { links.classList.remove('is-open'); }); }); }
    var yr = document.getElementById('year'); if (yr) yr.textContent = new Date().getFullYear();
    var els = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && els.length) {
      var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    } else { els.forEach(function (el) { el.classList.add('is-in'); }); }
  }

  renderReleases(); renderAlbum(); initGallery(); renderVideos(); renderSongs(); renderMerch(); wireChrome();
})();
